<template>
    <div class="fixedDitch">
        <div class="resource-search">
            <div class="inputSelect" :style="{'z-index':index == 0?9:8}" v-for="(item,index) in select" :key="index">
                <span>*</span>
                <p>{{item.name}}</p>
                <div class="input-box">
                    <i class="icon iconfont icon-zheng-triangle" :class="{'rotate-icon':item.isShow}"></i>
                    <div class="copyModel" @click.stop="bindChange($event,index)">{{item.cont}}</div>
                    <div class="select-box" :class="{'show-select':item.isShow}">
                        <ul :class="{'show-select':item.isShow}" @click.stop>
                            <li v-for="(val,key,j) in item.list" :key="j" @click="bindSelect($event,{val:val,key:key,index:index})">{{val}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="search-submit">
                <a href="javascript:" @click="submitBtn">查询</a>
            </div>
            <div class="add-link">
                <a href="javascript:" @click="changeShow">
                    <i class="iconfont icon-jia"></i>
                    <span>新增</span>
                </a>
            </div>
        </div>
        <div class="table-box">
            <table border="0">
                <tr class="table-title">
                    <td v-for="(item,index) in searchTitle" :key="index">{{item.name}}</td>
                    <td>操作</td>
                </tr>
                <tr v-for="(item,index) in pageArr" :key="index">
                    <td>{{item.group}}</td>
                    <td>{{item.medium}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.url}}</td>
                    <td>{{item.term}}</td>
                    <td class="td-edit">
                        <a class="table-remove" href="javascript:" @click="bindRemove($event,item.id)">删除</a>
                    </td>
                </tr>
            </table>
            <div class="list-hint" v-show="isShowTip" @click="isShowTip = false">
                <div class="list-hint-box" @click.stop>
                    <p class="p1">确认{{tip}}</p>
                    <p class="p2">
                        <a href="javascript:" @click="bindConfirm">确定</a>
                        <a href="javascript:" @click="isShowTip = false">取消</a>
                    </p>
                </div>
            </div>
        </div>
        <page @switchPage="bindSetPage" :pagesize="pageSize" :total="total" :isQuery="isQuery"></page>
    </div>
</template>

<script>
    import {mapGetters , mapActions} from "vuex";
    import  bus from './js/a.js';
    import page from "./page";
    export default {
        name:"fixedDitch",
        props:['searchData','searchTitle','searchUrl',"popu",'refresh',"isAjax"],
        data(){
            return {
                // 当前页面数据
                pageArr:[],
                tip:"",
                isShowTip:false,
                isRemove:false,
                dataId:0,
                groupList:"",
                // mediumList:"",
                pageSize:"",
                total:"",
                isQuery:0,
                // 
                // 是否显示select
                select:[
                    {name:"渠道组",isShow:false,cont:"请选择",list:[],id:''},
                    {name:"渠道媒介",isShow:false,cont:"请选择",list:[],id:''}
                ],
            }
        },
        watch:{
            "isAjax":function(val){
                this.submitData({name:'',identifying:'',page:1});
            },
            'refresh':function(){
                this.submitData({name:'',identifying:'',page:1});
            }
        },
        computed:{
            
        },
        mounted(){
            document.body.addEventListener("click",()=>{
                this.isSelect = this.isDitch = false;
            })
            this.submitData({name:'',identifying:'',page:1})
            let _this = this;
            bus.$on("bindPopuUpdate",function () { 
                _this.submitData({name:'',identifying:'',page:1});
            })
            this.groupList = this.getGroup;
            $.ajax({
                url:this.searchUrl+'getSearch',
                headers: {
                    'Auth-Token' : localStorage.getItem("token")
                },
                type:"POST",
                dataType:"JSON",
                success:(res)=>{
                    let one = res.data.group;
                    let tow = res.data.medium;
                    one["0"] = "请选择";
                    tow["0"] = "请选择";
                    this.select[0].list = one;
                    this.select[1].list = tow;
                }
            })
            $('body').on('click',()=>{
                for(let i in this.select){
                    this.select[i].isShow = false;
                }
            })
        },
        methods:{
            ...mapActions(['setHint']),
            // 查询
            submitData(data){
                if(localStorage.getItem("token")){
                    let _data = data;
                    let _this = this;
                    $.ajax({
                        url:_this.searchUrl+'getData',
                        headers: {
                            'Auth-Token' : localStorage.getItem("token")
                        },
                        type:"POST",
                        data:_data,
                        dataType:"JSON",
                        success:function(res){
                            _this.pageArr = res.data.list;
                            _this.pageSize = res.data.pageSize;
                            _this.total = res.data.total;
                        }
                    })
                }else{
                    this.$router.push({path:"/"})
                }
            },
            // 查询数据
            submitBtn(){
                this.add = 1;
                this.submitData({group:this.select[0].id,medium:this.select[1].id,page:1})
                ++this.isQuery;
            },
            // 父组件通信(跳转到新增页面)
            changeShow(){
                bus.$emit('bindBrother')
                this.$emit("getChild")
            },
            // 删除按钮
            bindRemove(event,id){
                this.tip = "删除";
                this.isShowTip = true;
                this.dataId = id;
            },
            // 确定操作
            bindConfirm(event,id){
                if(localStorage.getItem("token")){
                    let _this = this;
                    $.ajax({
                        url:_this.searchUrl+"delete",
                        headers: {
                            'Auth-Token' : localStorage.getItem("token")
                        },
                        type:"POST",
                        data:{id:this.dataId},
                        dataType:"JSON",
                        success:(res)=>{
                            this.isShowTip = false;
                            if(res.status == 1){
                                this.setHint({txt:res.msg,className:"hint-success"});
                                this.submitData({name:'',identifying:'',page:1})
                            }else{
                                this.setHint({txt:res.msg,className:"hint-error"})
                            }
                        }
                    })
                }else{
                    this.$router.push({path:"/"})
                }
            },
            bindSetPage(val){
                this.submitData({name:this.searchData[0].value,identifying:this.searchData[1].value,page:val})
            },
            // select选择
            bindSelect(event,val){
                this.select[val.index].cont = val.val;
                this.select[val.index].id = val.key;
                this.select[val.index].isShow = false;
            },
            // 
            bindChange(event,index){
                for(let i in this.select){
                    if(i == index){
                        this.select[index].isShow = !this.select[index].isShow;
                    }else{
                        this.select[i].isShow = false;
                    }
                }
            }
        },
        components:{
            page:page
        }
    }
</script>

<style scoped>
/*搜索栏*/
.resource-search {
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    font-size: 14px;
    color: #333;
    text-align: left;
    
}
/*模拟select*/
.search-resource {
    padding: 6px 12px;
}
.search-resource-input {
    position: relative;
    margin: 0 14px;
    
}
.search-resource-input input{
    position: relative;
    display: flex;
    align-content: center;
    width: 180px;
    height: 36px;
    line-height: 34px;
    padding: 0 12px;
    border: 1px #e4e4e4 solid;
    border-radius: 3px;   
    cursor: pointer;
}
/*筛选提交按钮*/
.search-submit,
.add-link {
    display: flex;
    align-items: center;
    padding: 6px 12px;
}
.search-submit a,
.add-link a{
    display: block;
    width: 120px;
    line-height: 36px;
    border-radius: 3px;
    background-color: #ffcc00;
    text-align: center;
    color: #fff;
    font-size: 16px;
}
.add-link a{
    background-color: #70ca10;
}
/*table 表单*/ 
.table-box {
    /* width: 700px; */
    /* min-height: 590px; */
    border-bottom: 1px #f7f7f7 solid;
    margin: 20px 0;
}
table {
    text-align: left;
    width: 100%;
    color: #333;
    border-collapse:collapse;
}
table tr:first-child td:nth-child(4) {
    width:40% !important;
}
tr {
    font-size:14px; 
}
tr:nth-child(odd){
    background-color: #f7f7f7;
}
tr td {
    position: relative;
    padding: 20px 30px;
}
tr td::after{
    position: absolute;
    content: "";
    height: 100%;
}
tr td a {
    vertical-align: middle;
}
.table-title {
    font-size: 16px;
    font-weight: bold;
}
.table-edit {
    color:#00BFFF;
}
.table-remove {
    color:red;
}

/*操作确认*/
.list-hint {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
    z-index: 88;
}

.list-hint-box {
    width: 200px;
    height: 120px;
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
}
.list-hint-box .p1 {
    height: 80px;
    line-height: 80px;
    border-bottom: 1px #ddd solid;
    font-size: 16px;
    color: #666;
}
.list-hint-box .p2 {
    height: 40px;
}
.list-hint-box .p2 a {
    display: inline-block;
    width: 50%;
    transition-duration: 600ms;
    color: red;
    font-size: 14px;
    line-height: 40px;
}
.list-hint-box .p2 a:first-child {
    border-right: 1px #ddd solid;
    color: deepskyblue;
}
.list-hint-box .p2 a:hover {
    background-color: #efefef;
}
/**/
/**/
/* .inputSelect .input-box .copyModel,
.input-box {
    width: 20px;
} */
.select-box {
    position: absolute;
    top: 50px;
    left: 0;
    width: 320px;
    max-height: 400px;
    padding: 3px 12px;
    border: 1px #e4e4e4 solid;
    border-radius: 6px;
    text-align: left;
    background-color: #fff;
    opacity: 0;
    -webkit-transition-duration: 600ms;
    transition-duration: 600ms;
    -webkit-transform: matrix(1, 0, 0, 1, 20, 0);
    transform: matrix(1, 0, 0, 1, 20, 0);
    pointer-events: none;
    overflow-y: scroll;
}
/*自适应*/
.inputSelect {
    width: 23% !important;
}
.input-box {
    width: 60% !important;
}
.copyModel,
.select-box{
    width: 100% !important;
}
.search-submit ,
.add-link {
    width: 16%;
}

/**/
.select-box ul {
    position: relative;
    width: 100%;
    top: 0 !important;
    transform: matrix(1,0,0,1,0,0);
    border: none;
}
.resource-search .inputSelect {
    width: auto;
    padding-right: 24px;
}
</style>




// WEBPACK FOOTER //
// src/components/main/popuList.vue